/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @typescript-eslint/explicit-member-accessibility */
import React, { Component, createRef } from 'react';
import { Icon, Table, Tooltip } from '@firesoon/antd';
import { cloneDeep, isEqual } from 'lodash';
import classNames from 'classnames';
import { Resizable } from 'react-resizable';
import { Screen } from '@firesoon/icons-react';
import { TableState, TableProp, ColumnProp } from './interface';
import { defaultPageConfig } from './config';
import ColSet from './ColSet';
import Empty from '../Empty';
import './index.less';
import FilterSearch from '../FilterSearch';

const ResizeableTitle = (props: any, hasResize: any) => {
  const { onResize, width, ...restProps } = props;

  if (width != null && hasResize) {
    return (
      <Resizable width={width ?? 100} height={0} onResize={onResize} draggableOpts={{ enableUserSelectHack: false }}>
        <th {...restProps} />
      </Resizable>
    );
  }

  return <th {...restProps} />;
};

class Index extends Component<TableProp, TableState> {
  static defaultProps = {
    columns: [],
    rowKey: (record: any, index: number) => record.ROW_ID || record.rowId || index,
    pagination: defaultPageConfig,
    className: '',
    hasResize: false,
    hasSet: false,
    isPopBody: true,
  };
  components: { header: { cell: (props: any) => any } };
  tableRef: React.RefObject<any>;

  constructor(props: any) {
    super(props);
    const { columns, hasResize } = props;

    this.state = {
      header: columns,
      preHeader: columns, // 避免state.header无法更新的bug
      setVisible: false,
      tableNode: null,
    };

    this.tableRef = createRef<any>();

    this.components = {
      header: {
        cell: (props) => ResizeableTitle(props, hasResize),
      },
    };
  }
  static getDerivedStateFromProps(nextProps: any, prevState: any) {
    const { columns } = nextProps;
    // 当传入的 columns 发生变化的时候，更新 state
    if (!isEqual(columns, prevState.preHeader)) {
      return {
        header: columns,
        preHeader: columns,
      };
    }
    // 否则，对于state不进行任何操作
    return null;
  }
  componentDidMount() {
    this.setState({
      tableNode: this.tableRef.current,
    });
  }
  componentDidUpdate(prevProps) {
    const { prevDataSource } = prevProps;
    const { dataSource } = this.props;
    const { header } = this.state;
    const tableBody = document.querySelector('.ant-table-body');
    const tableThead = document.querySelector('.ant-table-header');

    if (!isEqual(prevDataSource, dataSource) && header && tableBody && tableThead) {
      tableThead.scrollLeft = tableBody.scrollLeft;
    }
  }

  handleResize =
    (index: any) =>
    (_: any, { size }: any) => {
      this.setState(({ header }) => {
        const nextColumns = [...header];
        nextColumns[index] = {
          ...nextColumns[index],
          width: size.width,
        };
        return { header: nextColumns };
      });
    };
  updateCols = (cols: any) => {
    const { onSaveHeader } = this.props;

    this.setState(
      {
        header: cols,
      },
      () => {
        this.handleSetVisible(false);
        onSaveHeader?.(cols);
      },
    );
  };
  handleSetVisible = (value: any) => {
    this.setState({
      setVisible: value,
    });
  };

  render() {
    const { rowKey, pagination, className, dataSource, scroll, hasSet, isPopBody, locale, ...rest } = this.props;
    const { header, setVisible, tableNode } = this.state;

    const columns: Array<ColumnProp> = header
      .filter((item) => (!item.isHide && hasSet) || !hasSet)
      .map((item = {}, index) => {
        const { onHeaderCell, ...rest } = item;
        let result = {
          ...rest,
          onHeaderCell: (column: any) => {
            if (onHeaderCell) {
              return onHeaderCell(column);
            }
            return {
              width: column.width,
              onResize: this.handleResize(index),
            };
          },
        };
        if (result.filters && result.filters.length > 0) {
          result = {
            ...result,
            filterIcon: <Screen />,
            // eslint-disable-next-line react/no-unstable-nested-components
            filterDropdown: result.filterDropdown
              ? result.filterDropdown
              : ({ selectedKeys, setSelectedKeys, visible, confirm }) => {
                  return (
                    <FilterSearch
                      logInfo={result?.filterLogInfo}
                      multiple={result?.filterMultiple}
                      selectKeys={selectedKeys}
                      setSelectedKeys={setSelectedKeys}
                      confirm={confirm}
                      filter={result.filters}
                      visible={visible}
                      searchable={result?.searchable}
                    />
                  );
                },
          };
        }

        if (result.tips) {
          result = {
            ...result,
            title: (
              <span>
                {result.title}
                <Tooltip {...result.tips}>
                  <Icon type={result.tips.icon ?? 'info-circle'} style={{ marginLeft: 4 }} />
                </Tooltip>
              </span>
            ),
          };
        }

        return result;
      });

    hasSet &&
      columns.push({
        dataIndex: 'fs-table-set',
        title: (
          <ColSet
            columns={cloneDeep(header.filter((item) => item.dataIndex !== 'fs-table-set'))}
            updateCols={this.updateCols}
            visible={setVisible}
            handleDropdown={this.handleSetVisible}
            tableRef={tableNode}
            isPopBody={isPopBody}
          />
        ),
        width: 40,
        align: 'center',
        fixed: 'right',
        className: 'fs-table-setting-icon',
      });

    const restOpt = {
      ...rest,
      locale: {
        emptyText: <Empty type="table" />,
        ...locale,
      },
    };
    delete restOpt.columns;
    delete restOpt.hasResize;

    const options = {
      pagination: pagination ? { ...defaultPageConfig, ...pagination } : (false as false),
      className: classNames('fs-table', `${className}`, {
        'fs-table-scroll': !dataSource?.length && scroll?.x,
        'fs-table-tree-cols': columns.find((item) => item.children),
      }),
      getPopupContainer: () => document.body,
      rowKey,
      dataSource,
      scroll,
      components: this.components,
      columns,
      ...restOpt,
    };

    return (
      <div ref={this.tableRef} className="fs-table-wrapper">
        <Table {...options} />
      </div>
    );
  }
}

export default Index;
